import React, { useState } from 'react';

import { ReactComponent as Close } from '../../../assets/icons/close_black_24dp.svg';

import User from './AddUsersTenant.module.scss';
import { Constants } from '../../../config/Constants';
import config from '../../../config/aws-exports';
import { API } from 'aws-amplify';
import swal from 'sweetalert';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import { authData } from '../../../redux/auth/authSlice';
import { getCountryCodes } from './ContryCodes.jsx';

const AddUsersTenant = (props) => {
  let { handleAddClose, rows, getUsers } = props;
  const [userNameErr, setUserNameErr] = useState('');
  const [lastNameErr, setLastNameErr] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [pnoErr, setPnoErr] = useState('');
  const [genderErr, setGenderErr] = useState('');
  const [desigErr, setDesigErr] = useState('');
  const [departErr, setDepartErr] = useState('');
  const [orgErr, setOrgErr] = useState('');
  const [countryErr, setCountryErr] = useState('');
  const [cityErr, setCityErr] = useState('');
  const [stateErr, setStateErr] = useState('');
  const [pinErr, setPinErr] = useState('');
  const [addressErr, setAddressErr] = useState('');
  const [stdErr, setStdErr] = useState('');
  const [spin, setSpin] = useState(false);
  //const classes = useStyles();
  const [userName, setUserName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [pno, setPno] = useState('');
  const [gender, setGender] = useState('0');
  const [address, setAddress] = useState('');
  const [urole, setUrole] = useState('User');
  const [country, setCountry] = useState('');
  const [designation, setDesignation] = useState('');
  const [department, setDepartment] = useState('');
  const [organization, setOrganization] = useState('');
  const [city, setCity] = useState('');
  const [pin, setPin] = useState('');
  const [state, setState] = useState('');
  const [std, setStd] = useState('');
  const [gst, setGst] = useState('');
  const [pan, setPan] = useState('');
  // const [phone, setPhone] = useState('');
  //const [loading, setLoading] = useState(false);
  let userDetails = useSelector(authData);

  const onChangeHandlerUser = (event) => {
    setUserName(event.target.value);
  };

  const onChangeHandlerLastName = (event) => {
    setLastName(event.target.value);
  };

  const onChangeHandlerEmail = (event) => {
    setEmail(event.target.value);
  };
  const onChangeHandlerPno = (event) => {
    setPno(event.target.value);
  };
  const onChangeHandlerGender = (event) => {
    setGender(event.target.value);
  };
  const onChangeHandlerAddress = (event) => {
    setAddress(event.target.value);
  };
  const onChangeHandlerUrole = (event) => {
    setUrole(event.target.value);
  };

  const onChangeHandlerCountry = (e) => {
    setCountry(e.target.value);
  };

  const onChangeHandlerDesignation = (e) => setDesignation(e.target.value);
  const onChangeHandlerDepartment = (e) => setDepartment(e.target.value);
  const onChangeHandlerOrganization = (e) => setOrganization(e.target.value);
  const onChangeHandlerCity = (e) => setCity(e.target.value);
  const onChangeHandlerPin = (e) => setPin(e.target.value);
  const onChangeHandlerState = (e) => setState(e.target.value);
  const onChangeHandlerStd = (e) => setStd(e.target.value);
  const onChangeHandlerGST = (e) => setGst(e.target.value);
  const onChangeHandlerPAN = (e) => setPan(e.target.value);

  // useEffect(() => {
  //     getUsersDetails();
  //   }, []);
  const onsubmit = () => {
    console.log('data' + JSON.stringify(rows));
    let formIsValid = true;

    // 1. Reset all error messages first
    setUserNameErr('');
    setLastNameErr('');
    setEmailErr('');
    setPnoErr('');
    setStdErr('');
    setGenderErr('');
    setDesigErr('');
    setDepartErr('');
    setOrgErr('');
    setCountryErr('');
    setCityErr('');
    setPinErr('');
    setStateErr('');
    setAddressErr(''); // Added address error reset

    // 2. First Name Validation
    if (
      userName === '' ||
      userName === null ||
      (userName !== undefined && userName.trim() === '')
    ) {
      formIsValid = false;
      setUserNameErr('Please enter first name');
      // Removed 'return' so code continues
    } else if (!userName.match(/^[a-zA-Z ]*$/)) {
      // Check for valid characters only if not empty
      formIsValid = false;
      setUserNameErr('*Please enter alphabet characters only.');
    }

    // 3. Last Name Validation
    if (
      lastName === '' ||
      lastName === null ||
      (lastName !== undefined && lastName.trim() === '')
    ) {
      formIsValid = false;
      setLastNameErr('Please enter Last name');
    }

    // 4. Email Validation
    if (
      email === '' ||
      email === null ||
      (email !== undefined && email.trim() === '')
    ) {
      formIsValid = false;
      setEmailErr('*Please enter your email-ID.');
    } else {
      // Check email format only if email is not empty
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );
      if (!pattern.test(email)) {
        formIsValid = false;
        setEmailErr('*Please enter valid email-ID.');
      }
    }

    // Check duplicate email (only if email format is valid)
    if (rows !== undefined && rows.length > 0 && email !== '') {
      for (let i = 0; i < rows.length; i++) {
        if (email === rows[i].col2) {
          formIsValid = false;
          setEmailErr('User Already Exists as ' + rows[i].col3);
        }
      }
    }

    if (
      std === null ||
      std === undefined ||
      std.toString().trim() === '' ||
      std.toString().trim().length < 2 // most codes are at least 2 chars like "+1"
    ) {
      formIsValid = false;
      setStdErr('Please select a valid STD code');
    }

    // 5. Phone Number Validation
    if (
      pno === null ||
      pno === undefined ||
      pno.toString().trim() === '' ||
      pno.toString().trim().length < 10
    ) {
      formIsValid = false;
      setPnoErr(
        'Please enter a valid phone number (should be at least 10 digits)',
      );
    }

    // 6. Gender Validation
    if (gender === '0' || gender === '' || gender == null) {
      setGenderErr('Please select gender');
      formIsValid = false;
    }

    // 7. Designation Validation
    if (
      designation === '' ||
      designation === null ||
      (designation !== undefined && designation.trim() === '')
    ) {
      formIsValid = false;
      setDesigErr('Please enter Designation');
    }

    // 8. Department Validation
    if (
      department === '' ||
      department === null ||
      (department !== undefined && department.trim() === '')
    ) {
      formIsValid = false;
      setDepartErr('Please enter Department');
    }

    // 9. Organization Validation
    if (
      organization === '' ||
      organization === null ||
      (organization !== undefined && organization.trim() === '')
    ) {
      formIsValid = false;
      setOrgErr('Please enter Organization');
    }

    // 10. Country Validation
    if (
      country === '' ||
      country === null ||
      (country !== undefined && country.trim() === '')
    ) {
      formIsValid = false;
      setCountryErr('Please Enter Country');
    }

    // 11. City Validation
    if (
      city === '' ||
      city === null ||
      (city !== undefined && city.trim() === '')
    ) {
      formIsValid = false;
      setCityErr('Please enter City');
    }

    // 12. PIN Validation
    if (
      pin === '' ||
      pin === null ||
      (pin !== undefined && pin.trim() === '')
    ) {
      formIsValid = false;
      setPinErr('Please Enter Pin');
    }

    // 13. State Validation
    if (
      state === '' ||
      state === null ||
      (state !== undefined && state.trim() === '')
    ) {
      formIsValid = false;
      setStateErr('Please enter State');
    }

    // 14. Address Validation
    if (
      address === '' ||
      address === null ||
      (address !== undefined && address.trim() === '')
    ) {
      formIsValid = false;
      setAddressErr('Please enter Address'); // Fixed: Was setting StateErr
    }
    if (formIsValid === true) {
      Updateuser();
    }

    async function Updateuser() {
      setSpin(true);
      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          ur_id: 0,
          tenant: userDetails.tenantdata.tenantname,
          emailid: email.toLowerCase(),
          first_name: userName,
          last_name: lastName,
          dev: 2,
          urole: urole,
          st_id: userDetails.tenantdata.st_id,
          gen: parseInt(gender),

          designation: designation,
          department: department,
          organization: organization,
          country: country,
          city: city,
          pin: pin === '' ? null : pin, // Converting to null if empty
          state: state,
          std: std, // Country Code (from the dropdown)
          cno: pno, // Phone Number (from the input field)
          gst: gst,
          pan: pan,

          uid: '',
          officeAddress: address,

          atype: 0,
          schema: Constants.SCHEMA_NAME,
        },
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      };
      console.log('bd' + JSON.stringify(bodyParam.body));
      try {
        const response = await API.post(
          config.aws_cloud_logic_custom_name,
          Constants.ADD_USER,
          bodyParam,
          //`${Constants.GET_MY_PROGRAMS}`, bodyParam,
        );
        // const users = response;
        console.log(JSON.stringify(response));
        handleAddClose();
        getUsers();
        if (
          response.errorMessage !== undefined &&
          response.errorMessage === 'User already exists'
        ) {
          swal({
            title: 'Oops!',
            text: 'User already exists',
            icon: 'warning',
            dangerMode: false,
            closeOnClickOutside: false,
          }).then((willDelete) => {
            if (willDelete) {
              setSpin(false);
            }
          });
        } else {
          swal({
            title: 'Success',
            text: response.message,
            icon: 'success',
            dangerMode: false,
            closeOnClickOutside: false,
          }).then((willDelete) => {
            if (willDelete) {
              setSpin(false);
            }
          });
        }
      } catch (error) {
        setSpin(false);
        swal({
          title: 'Oooops!',
          text: 'Something went wrong!',
          icon: 'warning',
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            setSpin(false);
          }
        });
        console.log('getUserError', error);
      }
      console.log('Mount');
    }
  };

  return (
    <div className={User.maindiv}>
      {spin === false ? (
        <div className={User.maincontainer}>
          <div className={User.iconcontainer}>
            <h3 className={User.create}>Add user</h3>
            <Close className={User.closebutton} onClick={handleAddClose} />
          </div>

          {/* Container with Scroll and Grid Layout */}
          <div className={User.formContainer}>
            {/* First Name */}
            <div className={User.formGroup}>
              <label className={User.label}>
                First Name <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerUser}
                value={userName}
                required
              />
              <div className={User.errorMessage}>{userNameErr}</div>
            </div>

            {/* Last Name */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Last Name <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerLastName}
                value={lastName}
                required
              />
              <div className={User.errorMessage}>{lastNameErr}</div>
            </div>

            {/* Email */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Email <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='email'
                onChange={onChangeHandlerEmail}
                value={email}
                required
              />
              <div className={User.errorMessage}>{emailErr}</div>
            </div>

            {/* Ph. No */}
            {/* STD & Phone Number - COMBINED GROUP */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Phone Number <span className={User.required}>*</span>
              </label>
              <div className={User.flexRow}>
                {/* STD Dropdown using imported function */}
                <select
                  className={`${User.input} ${User.inputSmall}`}
                  onChange={onChangeHandlerStd}
                  value={std}
                >
                  <option value='' disabled>
                    STD
                  </option>
                  {getCountryCodes().map((item, index) => (
                    <option key={index} value={item.code}>
                      {item.code} ({item.country})
                    </option>
                  ))}
                </select>

                {/* Phone Input */}
                <input
                  className={User.input}
                  type='number'
                  placeholder='Phone Number'
                  onChange={onChangeHandlerPno}
                  value={pno}
                />
              </div>

              {(stdErr || pnoErr) && (
                <div className={User.errorMessage}>
                  {stdErr && pnoErr
                    ? 'Please select STD and enter phone number'
                    : stdErr || pnoErr}
                </div>
              )}
            </div>

            {/* Gender */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Gender<span className={User.required}>*</span>
              </label>
              <select
                className={User.input}
                onChange={onChangeHandlerGender}
                value={gender}
              >
                <option value='0'>Select</option>
                <option value='1'>Male</option>
                <option value='2'>Female</option>
              </select>
              <div className={User.errorMessage}>{genderErr}</div>
            </div>

            {/* User Role */}
            <div className={User.formGroup}>
              <label className={User.label}>
                User Role <span className={User.required}>*</span>
              </label>
              <select
                className={User.input}
                onChange={onChangeHandlerUrole}
                value={urole}
              >
                <option value='User'>Participant</option>
                <option value='Manager'>Manager</option>
              </select>
              <div className={User.errorMessage}></div>
            </div>

            {/* Designation */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Designation <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerDesignation}
                value={designation}
              />
              <div className={User.errorMessage}>{desigErr}</div>
            </div>

            {/* Department */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Department<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerDepartment}
                value={department}
              />
              <div className={User.errorMessage}>{departErr}</div>
            </div>

            {/* Organization */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Organization<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerOrganization}
                value={organization}
              />
              <div className={User.errorMessage}>{orgErr}</div>
            </div>

            <div className={User.formGroup}>
              <label className={User.label}>
                Country<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerCountry}
                value={country}
              />
              <div className={User.errorMessage}>{countryErr}</div>
            </div>

            {/* City */}
            <div className={User.formGroup}>
              <label className={User.label}>
                City<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerCity}
                value={city}
              />
              <div className={User.errorMessage}>{cityErr}</div>
            </div>

            {/* PIN */}
            <div className={User.formGroup}>
              <label className={User.label}>
                PIN Code<span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='number'
                onChange={onChangeHandlerPin}
                value={pin}
              />
              <div className={User.errorMessage}>{pinErr}</div>
            </div>

            {/* State */}
            <div className={User.formGroup}>
              <label className={User.label}>
                State <span className={User.required}>*</span>
              </label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerState}
                value={state}
              />
              <div className={User.errorMessage}>{stateErr}</div>
            </div>

            {/* STD Phone */}
            {/* <div className={User.formGroup}>
              <label className={User.label}>STD Phone</label>
              <input
                className={User.input}
                type='number'
                onChange={onChangeHandlerStd}
                value={std}
              />
              <div className={User.errorMessage}></div>
            </div> */}

            {/* GST Number */}
            <div className={User.formGroup}>
              <label className={User.label}>GST Number</label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerGST}
                value={gst}
              />
              <div className={User.errorMessage}></div>
            </div>

            {/* Company PAN */}
            <div className={User.formGroup}>
              <label className={User.label}>Company PAN</label>
              <input
                className={User.input}
                type='text'
                onChange={onChangeHandlerPAN}
                value={pan}
              />
              <div className={User.errorMessage}></div>
            </div>

            {/* Address - Full Width */}
            <div className={User.formGroup}>
              <label className={User.label}>
                Office Address <span className={User.required}>*</span>
              </label>
              <textarea
                className={User.textarea}
                rows='3'
                onChange={onChangeHandlerAddress}
                value={address}
              />
              <div className={User.errorMessage}>{addressErr}</div>
            </div>

            {/* Office Address - Full Width */}
            {/* <div className={User.formGroup}>
              <label className={User.label}>
                Office Address <span className={User.required}>*</span>
              </label>
              <textarea className={User.textarea} rows='3' />
              <div className={User.errorMessage}></div>
            </div> */}

            {/* Buttons */}
            <div className={User.buttonContainer}>
              <button className={User.cancel} onClick={handleAddClose}>
                Cancel
              </button>
              <button type='submit' onClick={onsubmit} className={User.submit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={User.root}>
          <CircularProgress style={{ color: config.main_color_1 }} />
        </div>
      )}
    </div>
  );
};
export default AddUsersTenant;
